import Moment from 'react-moment';
import NoImg from 'assets/img/no-img.jpg';
import { v4 as uuid } from 'uuid';
import clsx from 'clsx';
import { ChevronDownIcon } from 'components/icons/ChevronDownIcon';
import { useDispatch } from 'react-redux';
import { handleSecondaryViewOpen } from 'store/appSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import { setRecentVideoPrevNextGroup } from 'store/videoSlice';
import { useState, useEffect } from 'react';

export interface IHeaderMenu {
  id: string;
  icon?: JSX.Element;
  name: string;
  onClick?: () => void;
  devider?: boolean;
  current?: boolean;
  width?: number;
  pointer?: string;
  channel?: any;
  [key: string]: any;
}

export const HeaderMenuItem = ({ name, devider, avatar, video, channel, type, onClick }: IHeaderMenu) => {
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const location = useLocation();

  const channelIdRegex = /\/channel\/([^/]+)/;
  const channelMatch = location.pathname.match(channelIdRegex);
  const currentPage = channelMatch ? channelMatch[1] : 'home';
  const workspaceId = sessionStorage.getItem('workspace') || localStorage.getItem('last-active:workspace');

  const handleClick = () => {
    onClick && onClick();
    if ((currentPage === 'home' && !channel) || (channel && currentPage === channel.hash_id)) {
      dispatch(setRecentVideoPrevNextGroup({ key: 'home' }));
      const videoElement = document.getElementById((channel ? channel.hash_id : 'home') + '-' + video.id);
      videoElement?.click();
      videoElement?.scrollIntoView();
    } else {
      navigateTo(channel ? `workspace/${workspaceId}/user/channel/${channel.hash_id}` : '/home', {
        state: {
          fromNotification: true,
          videoElement: (channel ? channel.hash_id : 'home') + '-' + video.id,
          dateAdded: video.date_added,
          channelHashId: channel ? channel.hash_id : 'home'
        }
      });
    }
    const closeMenu = document.getElementById('menu-close');
    closeMenu?.click();
  };

  const [hasVideo, setHasVideo] = useState(!!video);
  useEffect(() => {
    setHasVideo(!!video);
  }, [video]);

  const handleSecondary = () => {
    handleClick();
    dispatch(
      handleSecondaryViewOpen({
        open: true,
        data: {
          id: video.id,
          name: video.name,
          duration: video.duration,
          views: video.views,
          dateAdded: video.date_added,
          displayThumbnail: video.display_thumbnail,
          displayNote: video.display_note,
          videoShots: video.video_shots,
          hashId: video.hash_id,
          channels: video.channels
        }
      })
    );
  };

  if (!hasVideo) {
    return null;
  }

  return (
    <>
      <div
        className="group relative flex items-center px-4 py-2 leading-7 text-sm cursor-pointer hover:bg-[#f8f8f8]"
        role="menuitem"
        tabIndex={-1}
        onClick={handleClick}
      >
        <div className="flex items-center flex-[0.7] grow">
          <div className="w-9 h-9 mr-[10px] mb-auto shrink-0 text-right leading-[1.3]">
            <img
              className="rounded-[4px] cursor-pointer w-full h-full"
              src={avatar ? avatar : NoImg}
              alt={`${name} - Image`}
            />
          </div>
          <div className="w-full grow shrink -mr-2 -ml-4 pr-2 pl-4 leading-5">
            <div>
              <a
                className="mr-[5px] text-iconColor font-lato no-underline font-black text-[15px]"
                href={`/users/${uuid}`}
              >
                {video.owner.name}
              </a>
              <small
                className={clsx('text-xs font-normal text-secondaryTime', {
                  // visible: avatar,
                  // invisible: !avatar
                })}
              >
                <Moment format="hh:mm ">{new Date(new Date().getTime() - new Date(video.date_added).getTime())}</Moment>
                ago
              </small>
            </div>
            <p className="text-[15px] font-lato font-normal text-iconColor">
              Shared a video in {type === 'video_added' ? '# home' : `# ${channel?.name}`}
            </p>
            <div className="text-black border-l-2 border-l-[#d0d0d0] pl-2 mt-2">
              <p className="text-blue-text">Title: {video.name}</p>
              <p className="text-[12.5px] my-1 line-clamp-2">People: {video?.people?.join(',')}</p>
              <div
                id="notes"
                className="group w-full text-xs py-[6px] px-[8px] border border-transparent hover:border-gray-200 rounded-sm flex items-center bg-transparent hover:bg-white cursor-pointer"
                onClick={handleSecondary}
              >
                <img src={avatar || NoImg} alt="" className="w-6 h-6 rounded-md mr-2" />
                <div className="truncate text-blue-text">{video.displayNote?.content}</div>
                <ChevronDownIcon className={`ml-auto -rotate-90 hidden group-hover:inline-block`} />
              </div>
            </div>
          </div>
        </div>
      </div>
      {devider && <div className="my-2 border-b border-gray-popup" />}
    </>
  );
};
